<template>
  <div class="writebox">
    <div class="writeboxcontent clearfix">
      <div class="star">
        <v-comments-star :disabled="true" :average_rating="average_rating"></v-comments-star>
        <span class="page_text_font">{{$t('comment.based_on')}} {{review_count || 0 }} {{$t('comment.reviews')}}</span>
      </div>
      <div class="star-bar-box">
        <div class="star-bar-item text_font" v-for="(item,index) in rating" :key="index">
          {{5-index}}
          <i class="el-rate__icon el-icon-star-on" style="color:#ffc124;"></i>
          <span>
            <i :style="'width:' +(item/review_count*100)+'%'"></i>
          </span>
          <em class="text_font">({{item}})</em>
        </div>
      </div>
      <div class="write_button secondary_title" @click="write_input_toggle">{{$t('comment.write_a_review')}}</div>
    </div>
    <v-comments-write-input ref="write_input" :product_id="product_id"></v-comments-write-input>
    <div class="review-ok">
      <h3>{{$t('comment.thank_you_for_posting_a_review')}}</h3>
      <p>{{$t('comment.we_value_your_input')}}</p>
      <span class="iconfont icon-cancel-1-copy" @click="$('.review-ok').hide()"></span>
    </div>
  </div>
</template>
<script>
import vCommentsWriteInput from "./commentsWriteInput";
import vCommentsStar from "./commentsstar";
export default {
  props: [
    "review_count",
    "average_rating",
    "rating_count",
    "comments",
    "product_id"
  ],
  data() {
    return {
      rating: []
    };
  },
  methods: {
    write_input_toggle() {
      this.$refs.write_input.toggle();
      console.log("write_input_toggle");
    }
  },
  beforeMount() {
    if (this.rating_count) {
      this.rating = Object.values(this.rating_count).reverse();
    }
    console.log(this.rating);
    console.log(this.rating_count);
    console.log("pro", this.pro);
  },
  components: {
    vCommentsWriteInput,
    vCommentsStar
  }
};
</script>
<style  lang='scss'>
.writebox {
  vertical-align: middle;
  .writeboxcontent {
    padding-bottom: 20px;
    .star {
      height: 18px;
      display: inline-flex;
      margin: 8px 0;
      padding-right: 50px;
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        padding-left: 4px;
      }
    }
    .star-bar-box {
      display: inline-block;
      vertical-align: middle;
      .star-bar-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        & > i {
          font-size: 18px;
          margin: 0 0 0 8px;
        }
        & > em {
          font-size: 16px;
          font-style: normal;
          color: #666;
          display: inline-block;
          min-width: 30px;
        }
        span {
          width: 200px;
          height: 7px;
          background: #f0f2f8;
          display: inline-block;
          margin: 0 10px;
          border-radius: 4px;
          position: relative;
          i {
            width: 0%;
            height: 7px;
            background: #ffc124;
            display: inline-block;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
    .write_button {
      float: right;
      cursor: pointer;
      font-size: 14px;
      margin-top: 32px;
      margin-right: 20px;
      border: 1px solid #ddd;
      padding: 12px 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .review-ok {
    font-size: 18px !important;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    text-align: center;
    padding: 40px 16px;
    background: #fafbff;
    position: relative;
    letter-spacing: 1px;
    display: none;
    span {
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
      -webkit-font-smoothing: antialiased;
      color: #333;
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}
@media screen and(max-width: 575px) {
  .writebox {
    .writeboxcontent {
      text-align: center;
      padding-bottom: 0px;

      .star {
        padding-right: 0;
      }
      .write_button {
        width: 100%;
        margin: 35px 0;
      }
    }
  }
}
</style>